import 'picturefill';

// Import scss so webpack will bundle it and export with ExtractTextPlugin
import '../scss/global.scss';

import './features/detectBrowser.js';
import './features/nav.js';
import './features/teamMobileCarousel.js';
import './features/whoCarousel.js';
import './features/smoothScroll.js';
